import React from 'react';
import './CapabilitiesSection.css';

const CapabilitiesSection = () => {
  const capabilities = [
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
          <path d="M6 12v5c3 3 9 3 12 0v-5" />
        </svg>
      ),
      title: 'Smart College Predictor',
      description: 'Anaiyre the neu smart college predictor results',
      color: 'navy'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
          <line x1="12" y1="6" x2="12" y2="10" />
          <line x1="12" y1="14" x2="12" y2="14" />
        </svg>
      ),
      title: 'Course & College Exploration',
      description: 'Analyze the college explorations',
      color: 'navy'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="4" width="20" height="16" rx="2" />
          <line x1="2" y1="10" x2="22" y2="10" />
          <line x1="12" y1="4" x2="12" y2="20" />
        </svg>
      ),
      title: 'Fees & Eligibility Clarity',
      description: 'Find thew fees & seats § fees and seats',
      color: 'navy'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
        </svg>
      ),
      title: 'Career Pathways',
      description: 'Learn more about international pathways',
      color: 'navy'
    }
  ];

  return (
    <section className="section capabilities-section">
      <div className="container">
        <h2 className="section-title">Student-Focused Platform Capabilities</h2>

        <div className="capabilities-grid">
          {capabilities.map((capability, index) => (
            <div key={index} className={`capability-card ${capability.color}`}>
              <div className="capability-icon">
                {capability.icon}
              </div>
              <h3 className="capability-title">{capability.title}</h3>
              <p className="capability-description">{capability.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CapabilitiesSection;
